export const log = (...args: any[]) => {
  // eslint-disable-next-line no-console
  console.error('AnimateCC:', ...args);
};
